import { render, staticRenderFns } from "./index.vue?vue&type=template&id=30bcb3fd&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=30bcb3fd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bcb3fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30bcb3fd')) {
      api.createRecord('30bcb3fd', component.options)
    } else {
      api.reload('30bcb3fd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=30bcb3fd&scoped=true", function () {
      api.rerender('30bcb3fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DMPaginatedTable/index.vue"
export default component.exports